import { createAction, props } from '@ngrx/store';
import { UserNotifications } from './user-notifications.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records user notifications'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records user notifications success', 
    props<{ listData: UserNotifications[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records user notifications failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record user notifications',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record user notifications success', 
    props<{ singleData: UserNotifications }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record user notifications failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record user notifications',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record user notifications success'
);
export const addRecordFailure = createAction(
    '[Data] Add record user notifications failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record user notifications',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record user notifications success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record user notifications failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record user notifications',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record user notifications success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record user notifications failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state user notifications',
);